import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import {useConfigModule} from "base/ui/module/provider";
import {useErrors} from "base/error/provider";
import {PermitService} from "permit/service";

import {ApprovedPermitSubPageMenu} from "permit/menu";
import {PageLayout} from "base/ui/main";

const ViewApprovedPermitPage = () => {
    const {id} = useParams();
    const {handleErrors} = useErrors();

    const [permit, setPermit] = useState(null);
    const location = useLocation();

    const {setModuleFilterValue, setModuleBasePath, isLoading, setIsLoading} =
        useConfigModule();

    useEffect(() => {
        setIsLoading(true);
        setPermit(null);
        setModuleBasePath(`/permits/approved/list/${id}`);
        PermitService.get(id)
            .then(data => {
                setModuleFilterValue(permit, data.id);
                setPermit(data);
            })
            .catch(error => {
                handleErrors(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id, location.state?.lastRefreshDate]);

    return (
        <PageLayout
            menu={<ApprovedPermitSubPageMenu permit={permit} />}
            context={[permit]}
            isLoading={isLoading}
            subPage
        />
    );
};

export default ViewApprovedPermitPage;
